import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid } from 'react-bootstrap';
import ModuleHeader from '../../components/ModuleHeader';
import FormTemplate from '../../components/FormTemplate';
import DistributorChecklist from './DistributorChecklist';
import { EMPTY_STRING, MODE_EDIT, MODE_ADD, FIRST_INDEX, EMPTY_COUNT, FIELD_CHECKBOX_INDETERMINATE, FIELD_SEND_DATETIME, SUCCESS, ERROR_BEHIND_DATA } from '../../../utils/constants';
import { contactOperations, contactSelectors } from './state';
import { ERROR_CONTACT_NOT_EXIST, ERROR_CONTACT_RETRIEVE, ERROR_EMPTY_ACTIVE_PROPOSAL, ERROR_CONTACT_CREATE, RELOAD_MASTER_UPDATED } from '../../../utils/messages';
import { CONTACT } from './routes';
import ErrorAlert from '../../components/ErrorAlert';
import $ from "jquery";
import Confirmation from '../../components/Confirmation';

class ViewDelivery extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mode: MODE_ADD,
            contactNumber: EMPTY_STRING,
            sendDateTime: EMPTY_STRING,
            title: EMPTY_STRING,
            message: EMPTY_STRING,
            proposalGroups: [],
            checkedPartners: [],
            error: [],
            isInsertAllowed: false,
            open: true,
            reload: false
        };
    }

    componentWillMount() {
        let id = this.props.match.params.id;

        if (undefined === id) {
            this.setActiveProposals();
        } else {
            this.setState({ mode: MODE_EDIT });

            this.props.view(id).then((result) => {
                if (null === result.data) {
                    this.setState({ error: [ERROR_CONTACT_NOT_EXIST], isInsertAllowed: false });
                } else {
                    let contact = result.data;
                    let formattedPartners = this.formatPartners(contact.partners);
                    let toggles = this.setToggles(formattedPartners);

                    this.setState({
                        contactNumber: contact.contactNumber,
                        sendDateTime: contact.sendDateTime,
                        title: contact.title,
                        message: contact.message,
                        proposalGroups: formattedPartners,
                        checkedPartners: formattedPartners,
                        isInsertAllowed: false,
                        toggles
                    });
                }
            }).catch(() => {
                this.setState({ error: [ERROR_CONTACT_RETRIEVE], isInsertAllowed: false });
            });
        }
    }

    setActiveProposals = () =>{
        this.props.getActiveProposals().then((result) => {
            if (null === result.data || EMPTY_COUNT === result.data.length) {
                this.setState({ error: [ERROR_EMPTY_ACTIVE_PROPOSAL], isInsertAllowed: false });
            } else {
                let activeProposals = result.data;
                let toggles = this.setToggles(result.data);
                let allPartners = [];
                activeProposals.map((proposal)=>allPartners.push.apply(allPartners, proposal.partners));

                this.setState({ proposalGroups: activeProposals, mode: MODE_ADD, isInsertAllowed: true, toggles, allPartners });
            }
        }).catch(()=>this.setState({ error: [ERROR_CONTACT_RETRIEVE], isInsertAllowed: false }));
    }

    formatPartners = (partners) => {
        let currentProposalId = EMPTY_STRING;
        let currentProposalName = EMPTY_STRING;
        let currentPartners = [];
        let proposalList = [];

        partners.map(partner => {
            if (EMPTY_STRING === currentProposalId) {
                currentProposalId = partner.proposalId;
                currentProposalName = partner.proposalName;
                currentPartners.push(partner);
            } else if (currentProposalId !== partner.proposalId) {
                proposalList.push({
                    proposalId: currentProposalId,
                    proposalName: currentProposalName,
                    partners: currentPartners
                })
                currentProposalId = partner.proposalId;
                currentProposalName = partner.proposalName;
                currentPartners = [];
                currentPartners.push(partner);
            } else {
                currentPartners.push(partner);
            }

            return EMPTY_STRING;
        });

        proposalList.push({
            proposalId: currentProposalId,
            proposalName: currentProposalName,
            partners: currentPartners
        });

        return proposalList;
    }

    setToggles = (partners) => {
        let toggles = {};

        partners.map((partner) => toggles[partner.proposalId] = false);

        return toggles;
    }

    toggleList = (proposalId) => {
        let newToggles = Object.assign({}, this.state.toggles);

        newToggles[proposalId] = !newToggles[proposalId];

        this.setState({ toggles: newToggles })
    }

    handleSubmit = () => {
        let errorList = contactSelectors.validate(this.state);

        if (EMPTY_COUNT < errorList.length) {
            this.setState({ error: errorList });
        } else {
            let contact = {
                title: this.state.title,
                message: this.state.message,
                partners: this.state.checkedPartners,
                userCode: this.props.user.user_cd,
            };

            if (MODE_ADD === this.state.mode) {
                this.props.addContactDelivery(contact).then((result) => {
                    if (SUCCESS === result.status) {
                        this.showList();
                    } else {
                        if (ERROR_BEHIND_DATA === result.data) {
                            this.setState({ reload: true});
                        }else{
                            this.setState({ error: [result.message] });
                        }
                    }
                }).then().catch(()=> this.setState({ error: [ERROR_CONTACT_CREATE] }));
            }
        }
    }

    handleCheckboxChange = (proposalId, event) => {
        let partner = JSON.parse(event.target.value);
        
        this.setState({
            [event.target.name]:
                contactSelectors.isPartnerChecked(this.state[event.target.name], partner)
                    ? this.state[event.target.name].filter(arr => (arr.customerCode1+arr.customerCode2) !== (partner.customerCode1+partner.customerCode2) )
                    : [...this.state[event.target.name], partner]
        }, ()=>{
            let group = this.state.proposalGroups.filter(group => group.proposalId === proposalId)[FIRST_INDEX];
            let checked = this.state.checkedPartners.filter(item => item.proposalId === proposalId);
            let hasSelected = EMPTY_COUNT < checked.length && group.partners.length > checked.length;

            if(hasSelected){
                this.setCheckboxIndeterminate(proposalId, true);
            }else{
                this.setCheckboxIndeterminate(proposalId, false);
            }
        });
    }

    handleGroupCheckboxChange = (event) => {
        let proposalId = event.target.value;
        let checked = this.state.checkedPartners.filter(item => item.proposalId === proposalId);
        let group = this.state.proposalGroups.filter(group => group.proposalId === proposalId)[FIRST_INDEX];
        let newPartners = Object.assign([], this.state.checkedPartners);

        if (EMPTY_COUNT < checked.length && group.partners.length >= checked.length) {
            newPartners = newPartners.filter(item => item.proposalId !== proposalId);
        } else {
            group.partners.map((partner) =>
                !contactSelectors.isPartnerChecked(this.state.checkedPartners, partner) ? newPartners.push(partner) : EMPTY_STRING
            )
        }

        this.setState({
            checkedPartners: newPartners
        });
    }

    handleParentCheckboxChange = (hasSelection) =>{
        if(hasSelection){
            this.setState({checkedPartners: []});
            Object.keys(this.state.toggles).map(key=>$(`#indeterminate_${key}`)[FIRST_INDEX].indeterminate=false);
        }else{
            this.setState({checkedPartners: this.state.allPartners});
        }
    }

    setCheckboxIndeterminate(proposalId, flag){
        let checkbox = $(`#indeterminate_${proposalId}`)[FIRST_INDEX];
        checkbox.indeterminate = flag;
    }

    setParentCheckboxIndeterminate(){
        let isChecked = EMPTY_COUNT < this.state.checkedPartners.length;
        let hasSelected = isChecked && this.state.allPartners.length >= this.state.checkedPartners.length;
        let allSelected = this.state.allPartners.length === this.state.checkedPartners.length;
        let checkbox = $(`#${FIELD_CHECKBOX_INDETERMINATE}`)[FIRST_INDEX];
        checkbox.indeterminate = false;

        if(isChecked && !allSelected){
            checkbox.indeterminate = true;
        }

        return hasSelected;
    }

    handleInputChange = (event) => {
        let fieldName = event.target.name;
        if(FIELD_SEND_DATETIME !== fieldName && MODE_ADD === this.state.mode){
            this.setState({ [event.target.name]: event.target.value });
        }
    }

    showList = () => {
        this.props.history.push(CONTACT);
    }

    showReload = () => {
        return this.state.reload && (
            <Confirmation
                message={RELOAD_MASTER_UPDATED}
                showConfirmation={true}
                buttons={[
                    { label: "OK", action: ()=>window.location.reload() },
                ]}
            />
        );
    }

    render() {
        return (
            <Grid fluid={true}>
                <Grid>
                    {this.showReload()}

                    <ModuleHeader title={"事業者→取引先連絡配信"} />

                    <ErrorAlert errors={this.state.error}/>

                        <FormTemplate
                            {...this.props}
                            {...this.state}
                            className="contact-delivery"
                            horizontal={true}
                            handleInputChange={this.handleInputChange}
                            disabled={!this.state.isInsertAllowed}
                            hasGroupSelected={this.state.allPartners ? this.setParentCheckboxIndeterminate() : false}
                            handleParentCheckboxChange={this.handleParentCheckboxChange}
                            distributorComponent={
                                <DistributorChecklist
                                    list={this.state.proposalGroups}
                                    handleCheckboxChange={this.handleCheckboxChange}
                                    handleGroupCheckboxChange={this.handleGroupCheckboxChange}
                                    checkedPartners={this.state.checkedPartners}
                                    toggles={this.state.toggles}
                                    toggleList={this.toggleList}
                                    view={MODE_EDIT === this.state.mode}
                                />
                            }
                            formButtons={[
                                { label: "配信", onClick: () => this.handleSubmit(), disabled: !this.state.isInsertAllowed },
                                { label: "戻る", onClick: () => this.showList() }
                            ]}
                        />

                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.auth.credentials,
        formInputs: state.contact.deliveryForm
    }
};

const mapDispatchToProps = {
    view: contactOperations.viewContact,
    getActiveProposals: contactOperations.getActiveProposals,
    addContactDelivery: contactOperations.addContactDelivery
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewDelivery);